import useEmblaCarousel from "embla-carousel-react";
import hero1 from "images/hero1.png";
import hero2 from "images/hero2.png";
import hero3 from "images/hero3.png";
import Autoplay from "embla-carousel-autoplay";
import {
  HeroContainer,
  HeroInner,
  HeroSlide,
  HeroSlideContainer,
} from "./Hero.styles";
import { Button } from "components";

interface HeroProps {
  variants: any;
  initial: any;
  animate: any;
  transition: any;
}

export const Hero = ({ variants, initial, animate, transition }: HeroProps) => {
  const [emblaRef] = useEmblaCarousel({ loop: true }, [
    Autoplay({ delay: 3000 }),
  ]);

  return (
    <HeroContainer
      ref={emblaRef}
      variants={variants}
      initial={initial}
      animate={animate}
      transition={transition}
    >
      <HeroInner>
        {/* <HeroSlide
          style={{
            backgroundImage: `url(${hero2})`,
          }}
        >
          <HeroSlideContainer>
            <Button
              variant="tertiary"
              size="large"
              onClick={() => {
                window.open(
                  "https://store.steampowered.com/app/3734200/Desktop_Heroes",
                  "_blank"
                );
              }}
            >
              TRY DEMO!
            </Button>
          </HeroSlideContainer>
        </HeroSlide> */}
        <HeroSlide
          style={{
            backgroundImage: `url(${hero1})`,
          }}
        >
          <HeroSlideContainer>
            <Button
              variant="tertiary"
              size="large"
              onClick={() => {
                window.open(
                  "https://store.steampowered.com/app/3734200/Desktop_Heroes",
                  "_blank"
                );
              }}
            >
              WISHLIST NOW!
            </Button>
          </HeroSlideContainer>
        </HeroSlide>
        <HeroSlide
          style={{
            backgroundImage: `url(${hero3})`,
          }}
        >
          <HeroSlideContainer>
            <Button
              variant="tertiary"
              size="large"
              onClick={() => {
                window.open(
                  "https://store.steampowered.com/app/3839440/Farm_BoYS/",
                  "_blank"
                );
              }}
            >
              WISHLIST NOW!
            </Button>
          </HeroSlideContainer>
        </HeroSlide>
      </HeroInner>
    </HeroContainer>
  );
};
